import type { JWMView } from '@atlassian/jira-business-common/src/common/types/jwm-view.tsx';
import type { BaseIssueNode } from '@atlassian/jira-business-list-handlers/src/controllers/list-cache/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { PARENT_TYPE } from '@atlassian/jira-platform-field-config';
import type { ViewIssue } from './types';

export const generateParentRankField = (rank: string | undefined) =>
	rank ? [{ aliasFieldId: 'rank', text: rank, __typename: 'JiraSingleLineTextField' }] : null;

const generateParentField = (
	issueId?: string,
	key?: string,
	id?: string,
	rank?: string,
	view?: JWMView,
) => {
	const shouldHaveIdAttribute = fg('jsw_list_view_-_all_the_fields') && view === 'list';

	return {
		aliasFieldId: null,
		fieldId: PARENT_TYPE,
		type: PARENT_TYPE,
		name: 'Parent',
		parentIssue:
			issueId && key
				? {
						__typename: 'JiraIssue',
						issueId,
						key,
						...(shouldHaveIdAttribute ? { id } : {}),
						rankField: generateParentRankField(rank),
					}
				: null,
		__typename: 'JiraParentIssueField',
	};
};

export const generateIssueWithUpdatedParent = (
	issue: BaseIssueNode,
	newParentIssue?: ViewIssue,
	view?: JWMView,
): BaseIssueNode => {
	const {
		issueId: newParentIssueId,
		key: newParentKey,
		id: newParentId,
		rank: newParentRank,
	} = newParentIssue || {};
	const parentFieldIndex = issue?.fields?.findIndex(
		(field) => field.type === PARENT_TYPE || field.fieldId === PARENT_TYPE,
	);

	const shouldHaveIdAttribute = fg('jsw_list_view_-_all_the_fields') && view === 'list';

	const parentField =
		parentFieldIndex !== -1 && parentFieldIndex !== undefined
			? {
					...issue?.fields?.[parentFieldIndex],
					parentIssue:
						!newParentIssueId || !newParentKey
							? null
							: {
									...(shouldHaveIdAttribute ? { id: newParentId } : {}),
									issueId: newParentIssueId,
									rankField: generateParentRankField(newParentRank),
									key: newParentKey,
									__typename: 'JiraIssue',
								},
				}
			: generateParentField(newParentIssueId, newParentKey, newParentId, newParentRank, view);

	return {
		...issue,
		fields: [
			...(issue?.fields?.filter(
				(field) => field.type !== PARENT_TYPE && field.fieldId !== PARENT_TYPE,
			) || []),
			parentField,
		],
	};
};
